import { useState } from "react";
import styles from "./SpringCamp.module.css";
import EnrollmentForm from "../enrollment/EnrollmentForm";

const SpringCamp = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  return (
    <div className={styles.pageWrapper}>
      <div className={styles.container}>
        {/* Header Section */}
        <header className={styles.header}>
          <nav className={styles.breadcrumb}>Programs • Special Events</nav>
          <h1 className={styles.mainHeading}>
            Spring Art Camp 2026 <br />
          </h1>
          <p className={styles.subtext}>
            Join us for a week of color, creativity, and new friendships. All
            materials are provided!
          </p>
        </header>

        {/* Flyer & CTA Section */}
        <div className={styles.contentLayout}>
          <div className={styles.flyerWrapper}>
            <img
              src="/assets/imgs/gallery/Spring_camp.png"
              alt="Spring Camp Flyer"
              className={styles.flyerImage}
            />
          </div>

          <div className={styles.ctaBox}>
            <div className={styles.infoCard}>
              <h3>Ready to create?</h3>
              <p>
                Secure your spot today. Spaces are limited to ensure
                personalized instruction for every child.
              </p>

              <button
                className={styles.enrollButton}
                onClick={() => setModalOpen(true)}
              >
                Enroll Now
              </button>

              {isModalOpen && (
                <EnrollmentForm
                  isOpen={isModalOpen}
                  onClose={() => setModalOpen(false)}
                  selectedProgram="Spring Camp 2026"
                />
              )}

              <ul className={styles.perksList}>
                <li>✨ Ages 6 - 15</li>
                <li>🎨 All Skill Levels</li>
                <li>🍎 Snacks Included</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpringCamp;
